const dowloadFileFromData = (prefix: string, data: any, filename: string) => {
    const link = window.document.createElement('a');
    link.setAttribute('href', prefix + encodeURI(data.toString()));
    link.setAttribute('download', filename);
    link.click();
    link.remove();
};

export default dowloadFileFromData;
